export default "__VITE_ASSET__rB0k9eT1__"